module.exports = __webpack_public_path__ + "static/media/208-Arzt_ID_2.83ef9142.mp3";